import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import classNames from 'classnames';
import styles from './NextArticleNav.module.styl';

const NextArticleNav = ({ to, headline }) => (
  <nav className={classNames(styles.nextArticleNav)}>
    <Link
      className="bentoncond-n4"
      to={to}
    >
      {`Next Story: ${headline}`}
    </Link>
  </nav>
);

NextArticleNav.propTypes = {
  to: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
};

export default NextArticleNav;
